import React from "react";
import "./index.css";
import { LightningSearchTypeEnum } from "@/util/cosntants";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";

type ColorItem = {
  range: string;
  color: string;
};

interface WarningColorBarProps {
  colors: ColorItem[];
  className?: string;
  showLabels?: boolean;
  searchType: LightningSearchTypeEnum;
}

const WarningColorBar: React.FC<WarningColorBarProps> = ({
    colors,
    className = "",
    showLabels = true,
    searchType,
}) => {
    const windowWidth = useSelector((state: RootState) => state.lightningReducer.windowWidth);

    // 计算每个色块的宽度百分比
    const calculateWidths = () => {
        const ranges = colors.map((item) => {
            const [start, end] = item.range.split("-").map(Number);
            return { start, end };
        });

        const totalWidth = ranges.reduce((sum, range) => sum + (range.end - range.start), 0);
        return ranges.map((range) => ((range.end - range.start) / totalWidth) * 100);
    };

    const widths = calculateWidths();

    // 计算显示的标题文本
    const getShowTitle = (range: string) => {
        let showTitle = range;
        if (searchType === LightningSearchTypeEnum.PROBABILITY) {
            const [start, end] = range.split("-").map(Number);
            showTitle = `${(start * 100).toFixed(0)}-${(end * 100).toFixed(0)}`;
        } else if (searchType === LightningSearchTypeEnum.FIRSTSTRIKE) {
            const [start, end] = range.split("-").map(Number);
            showTitle = `${start.toFixed(0)}-${end.toFixed(0)}`;
        }
        return showTitle;
    };

    // 根据窗口宽度和索引确定是否显示标签内容
    const shouldShowLabelContent = (index: number) => {
        if (!showLabels) return false;

        if (windowWidth < 768) {
            return index === 0 || index === colors.length - 1;
        } else if (windowWidth <= 1150) {
            return index % 2 === 1;
        } else {
            return true;
        }
    };

    return (
        <div className={`warning-color-bar ${className}`}>
            <div className="color-bar-container">
                {colors.map((item, index) => {
                    const showTitle = getShowTitle(item.range);
                    const showContent = shouldShowLabelContent(index);

                    return (
                        <div
                            key={index}
                            className="color-block-wrapper"
                            style={{ width: `${widths[index]}%` }}
                        >
                            <div
                                className="color-block"
                                style={{ backgroundColor: item.color }}
                                title={showTitle}
                            />
                            {/* 始终保留标签容器，只控制内容显示 */}
                            <span className="color-label-placeholder">
                                {showContent ? showTitle : <span className="invisible-placeholder">&nbsp;</span>}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default WarningColorBar;